'use strict';

const debuglog = require('util').debuglog('instance-location');
const { initGeo } = require('./geo/index.js');

/**
 * @typedef {import('./geo/index.js').Geo} Geo
 */

/** @type {Geo|undefined} */
let geo;

/** @type {string|undefined} */
let az;

/** @type {string|undefined} */
let region;

/** @type {string|undefined} */
let datacenter;

/**
 * Initializes and stores `geo`, `az`, `region`, and `datacenter` from `process.env`.
 *
 * - `geo` initialized from `process.env.instance_geo`
 *
 * - `az` initialized from `process.env.instance_az`
 *
 * - `region` initialized from `process.env.instance_region`
 *
 * - `datacenter` initialized from `process.env.instance_datacenter`
 *
 * Debuggable with Node.js `util.debuglog` - Set env variable `NODE_DEBUG` to `instance-location`.
 */
function init() {
  geo = initGeo(process.env.instance_geo);
  debuglog('INFO: geo: %s', geo);

  az = process.env.instance_az;
  debuglog('INFO: az: %s', az);

  region = process.env.instance_region;
  debuglog('INFO: region: %s', region);

  datacenter = process.env.instance_datacenter;
  debuglog('INFO: datacenter: %s', datacenter);
}

// run init upon module initialization to get location values (main use)
init();

/** @return {string|undefined} geo value */
function getGeo() {
  return geo && geo.name;
}

/** @return {string|undefined} geo value in lower case */
function getGeoLower() {
  return geo && geo.nameLower;
}

/** @return {string|undefined} az value */
function getAz() {
  return az;
}

/** @return {string|undefined} region value */
function getRegion() {
  return region;
}

/** @return {string|undefined} datacenter value */
function getDataCenter() {
  return datacenter;
}

/** @return {string|undefined} geo-specific domain value */
function getPayPalDomain() {
  return geo && geo.domain;
}

/** @return {string|undefined} geo-specific PayPal internal inc domain */
function getPayPalIncDomain() {
  return geo && geo.ppinc;
}

/** @return {string|undefined} geo-specific PayPal internal corp domain */
function getPayPalCorpDomain() {
  return geo && geo.ppcorp;
}

/** @return {string|undefined} geo-specific staging host domain */
function getStagingHostName() {
  return geo && geo.stage;
}

/** @return {string|undefined} geo-specific cdnhost name */
function getCdnHostName() {
  return geo && geo.cdnhost;
}

module.exports = {
  init,
  getGeo,
  getGeoLower,
  getAz,
  getRegion,
  getDataCenter,
  getPayPalDomain,
  getPayPalIncDomain,
  getPayPalCorpDomain,
  getStagingHostName,
  getCdnHostName,
};
